import { Dispute } from 'graphql/generated/graphql';
import { axios } from 'utils/networkRequests';

export const disputes = {
  create: (values: { dispute: Partial<Dispute> }) => axios.post('/v3/facility/disputes', values),
  cancel: (disputeId: number) => axios.put(`/v3/facility/disputes/${disputeId}/cancel`),
};
